﻿import { findTargetMilestoneRecursive } from "@/helpers";
import { IMilestoneBase } from "@/interfaces";
import { isValidProductCategory } from ".";
import { IGetMilestones } from "../";

export const getNestedMilestones = ({
  isTemplate,
  milestoneTemplates,
  project,
  flattenedMilestones,
  parentId,
}: IGetMilestones): IMilestoneBase[] => {
  let parentMilestone = findTargetMilestoneRecursive(
    flattenedMilestones,
    parentId
  );

  if (isTemplate && parentMilestone?.milestoneTemplateId) {
    parentMilestone = findTargetMilestoneRecursive(
      milestoneTemplates,
      parentMilestone.milestoneTemplateId
    );
  }
  if (!parentMilestone?.childMilestones?.length) return [];

  return parentMilestone.childMilestones.filter((milestone: IMilestoneBase) => {
    if (!isTemplate && milestone.canBeAdded) return true;
    return (
      milestone.isActive &&
      isTemplate &&
      isValidProductCategory(milestone, project)
    );
  });
};
